import React from "react";
import Slider from "react-slick";
import "../../assets/vendor/slick-master/slick/slick.scss";
import "../../assets/vendor/slick-master/slick/slick-theme.scss";
// import "~slick-carousel/slick/slick.css";//yarn added slick-carousel
// import "~slick-carousel/slick/slick-theme.css";
// import FeatureOfferCard from "../../components/FeatureOfferCard";
// import "./FeatureOfferSlider.scss";

import CustomImg from "../../components/common/CustomImg";
// import "./FeatureSlider.scss";
import { useQuery } from "react-query";
import { ApiNames, fetchData } from "../../remote-data/fetchData";
import { Link } from "react-router-dom";
import { bannerType } from "../../constants/serverConstants";
// import { useQueryOfferByCode, useQuerySubMerchantByCode } from "../../utils/banner";
// import { Link } from "react-router-dom";

function FeatureOfferSlider(props) {
  const settings = {
    centerMode: true,
    centerPadding: "300px",
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1, //4 or 5 in large screens
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 1199,
        settings: {
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          dots: true,
        },
      },
    ],
  };

  const { data: postData, isLoading: isPostLoading } = useQuery(
    ApiNames.BANNER_LIST,
    () =>
      fetchData(ApiNames.BANNER_LIST, {
        // pathValues: [props.spaceId],
      })
  );

  // API: GET
  // const { data: offerTest, isLoading: isOfferTestLoading } = useQueryOfferByCode("i49t70");
  // const { data: subMerchantTest, isLoading: isSubMerchantTestLoading } = useQuerySubMerchantByCode("63l8Lx");

  // if (!postData || isPostLoading) return null;
  //   return <Loader className="position-absolute h-0" />;

  // if (isPostLoading || !postData) return <Loader />;
  if (isPostLoading || !postData) return null;

  // console.log(postData);
  return (
    <>
      {postData && postData.data.banners.length > 0 && (
        <Slider className="feature-slider" {...settings}>
          {postData.data.banners.map((postItem, index) => {
            let id = postItem.id;
            let link = postItem.link;
            let linkType = postItem.linkType;

            let newLink = null;
            if (linkType === bannerType.EXT_LINK) {
              newLink = link;
            }
            if (linkType === bannerType.OFFER_LINK) {
              newLink = `/offerDetails/${link}`;
            }
            if (linkType === bannerType.MERCHANT_LINK) {
              newLink = `/merchants/${link}`;
            }
            if (linkType === bannerType.SELF_DESCRIPTION) {
              newLink = `/banners/${id}`;
            }
            return (
              <div key={index} className="feature-offer">
                <div className="card">
                  {/* {console.log(newLink)} */}
                  {linkType === bannerType.EXT_LINK ? (
                    <a href={newLink} target="_blank" rel="noreferrer noopener">
                      <BannerImg
                        url={postItem.image}
                        title={postItem.title}
                        description={postItem.description}
                      />
                    </a>
                  ) : (
                    <Link to={newLink}>
                      <BannerImg
                        url={postItem.image}
                        title={postItem.title}
                        description={postItem.description}
                      />
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      )}
    </>
  );
}

const BannerImg = ({ url, title, description }) => (
  <>
    <CustomImg
      // url={`/img/slider-${postItem}.png`}
      url={url}
      width="1000"
      height="385"
    />

    <div className="banner-caption offers position-relative">
      <div className="offer-text position-absolute">
        <h4 className="caption-title">{title}</h4>
        <small>{description}</small>
      </div>
    </div>
  </>
);

export default FeatureOfferSlider;
